import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";
import { useCourses } from "../../../../hooks/useCourses";


export function FilterCourseInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const {
    courses,
  } = useCourses();
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {courses.map((course: any) => (
        <MenuItem key={course.course} value={course.course}>
          {course.course}
        </MenuItem>
      ))}
    </Select>
  );
}